export default {
    parts: ['container', 'stack', 'button'],
    baseStyle: {
        container: {
            justifyContent: {base: 'flex-end', lg: 'center'}
        },
        stack: {
            gap: 6
        },
        button: {
            p: 0,
            minW: 'auto',
            h: 'auto',
            borderRadius: 0,
            pb: 1,
            display: 'flex'
        }
    }
}
